import React from 'react';
import { shallowEqual, useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { casualPageConfig } from '@/pages/dashboard/pages/engagement/lt/casualPageConfig';
import { IDataFrame, ISelectorState } from '@/pages/dashboard/types/dashboard';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import './index.scss';
const reqParams = '/engagement/lt';

const Lt = () => {
  const dataFrame = useSelector((state: ISelectorState) => {
    return state?.dashboard?.currentGame?.data_frame || 'casual';
  }, shallowEqual);

  const pageMap: Partial<Record<IDataFrame, IPageConfigType>> = {
    casual: casualPageConfig as unknown as IPageConfigType,
  };

  return (
    <>
      <CommonPageRender
        reqParams={reqParams}
        pageConfigInit={pageMap?.[dataFrame]}
      />
    </>
  );
};

export default Lt;
